import { Component, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-service-contact-form',
  templateUrl: './service-contact-form.component.html',
  styleUrls: ['./service-contact-form.component.scss']
})
export class ServiceContactFormComponent {

  @Input() ContactForm: FormGroup = new FormGroup({
    Name: new FormControl('', Validators.required),
    LastName: new FormControl(''),
    PhoneNumber: new FormControl('', Validators.required),
    Email: new FormControl('', Validators.required),
    IsContactParticular: new FormControl('', Validators.required),
  })

  @Input() hideErrors: boolean = false;

  @Input() ShowExternalContainer: boolean = false;
  @Input() ShowEmailOptional: boolean = false;

  @Input() disableParticularContact: boolean = false;
  @Input() disableCorporativeContact: boolean = false;
  @Input() disableCorporativeBoxContact: boolean = false;
  @Input() disableParticularBoxContact: boolean = false;


  ngOnInit() {
    const lastNameCtrl = this.ContactForm.get('LastName');
  }

  onOriginPhoneNumberChange(phoneNumber: string) {
    this.ContactForm.get('PhoneNumber')?.patchValue(phoneNumber);
  }

  selectOption(value: boolean) {
    this.ContactForm.get('IsContactParticular')?.patchValue(value);
  }

}
